var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BorderAnimation',{staticClass:"flex-grow-0",staticStyle:{"height":"220px","width":"60%"}},[_c('ul',{staticClass:"pl-0",attrs:{"data-test":"step-view"}},_vm._l((_vm.stepsHint),function(hint,idx){return _c('li',{key:idx,staticClass:"list-style-none",class:hint.className},[_vm._v(" "+_vm._s(hint.text)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }